import {
	PreloaderState,
	PUBLIC_PRELOADER_ACTION,
	PublicPreloaderAction,
	SECURE_PRELOADER_ACTION,
	SecurePreloaderAction
} from "components/preloader/types";

const initialState: PreloaderState = {
	publicPreloader: {
		isPreloadDone: false
	},
	securePreloader: {
		isPreloadDone: false
	}
};

export function preloaderReducer(
	state: PreloaderState = initialState,
	action: PublicPreloaderAction | SecurePreloaderAction
): PreloaderState {
	switch (action.type) {
		case PUBLIC_PRELOADER_ACTION.PRELOAD_SUCCESS:
			return {
				...state,
				publicPreloader: {
					isPreloadDone: true
				}
			};
		case PUBLIC_PRELOADER_ACTION.PRELOAD_FAILED:
			return {
				...state,
				publicPreloader: {
					...state.securePreloader,
					errorMsg: action.payload.errorMsg
				}
			};
		case SECURE_PRELOADER_ACTION.PRELOAD:
			console.log("secure preload requested");
			return { ...state };
		case SECURE_PRELOADER_ACTION.PRELOAD_SUCCESS:
			return {
				...state,
				securePreloader: {
					isPreloadDone: true
				}
			};
		case SECURE_PRELOADER_ACTION.PRELOAD_FAILED:
			return {
				...state,
				securePreloader: {
					...state.securePreloader,
					errorMsg: action.payload.errorMsg
				}
			};
		default:
			return state;
	}
}
